import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";

const HomePagePropertyType = () => {
  const navigate = useNavigate();
  const [propertyType, setPropertyType] = useState();

  function submitSearch(data) {
    navigate(`/divine-bricks-property-listing?typeArr=${data}`);
  }
  return (
    <>
      <section
        className="property-type-section"
        style={{
          background: "#FEF7E9",
          padding: "40px",
          paddingBottom: "80px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-4" style={{ textAlign: "left" }}>
              <h3
                style={{
                  color: "#5C5959",
                  fontSize: "40px",
                  fontWeight: "700",
                  lineHeight: "45px",
                  fontFamily: "lato",
                }}
              >
                Explore <br /> by Property Type
              </h3>
              <p
                style={{
                  color: "#5C5959",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                In real estate, properties can be classified into various types
                based on their use, structure, or purpose
              </p>
              <button
                className="normal-zoom"
                style={{
                  background: "#FCE5B3",
                  border: "none",
                  borderRadius: "2px",
                  padding: "5px 16px",
                  color: "#5C5959",
                }}
              >
                View Properties &rarr;
              </button>
            </div>
            <div className="col-md-8">
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className="carousel-item-padding-40-px"
                containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                keyBoardControl
                minimumTouchDrag={80}
                partialVisible
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 3000,
                      min: 1024,
                    },
                    items: 3,
                    partialVisibilityGutter: 20,
                  },
                  mobile: {
                    breakpoint: {
                      max: 464,
                      min: 0,
                    },
                    items: 1,
                    partialVisibilityGutter: 30,
                  },
                  tablet: {
                    breakpoint: {
                      max: 1024,
                      min: 464,
                    },
                    items: 2,
                    partialVisibilityGutter: 30,
                  },
                }}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
              >
                <div
                  className="card propertyTypeCard"
                  onClick={() => {
                    submitSearch("villa");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="89"
                    height="80"
                    viewBox="0 0 89 80"
                    fill="none"
                    alt="divine-bricks-villa"
                    title="divine-bricks-villa"
                  >
                    <path
                      d="M65.8988 41.5556H56.3857C55.8808 41.5556 55.4724 41.9641 55.4724 42.4689V51.3817C55.4724 51.8866 55.8808 52.2951 56.3857 52.2951H65.8988C66.4036 52.2951 66.8121 51.8866 66.8121 51.3817V42.4689C66.8121 41.9641 66.4036 41.5556 65.8988 41.5556ZM60.2289 50.4684H57.299V47.8391H60.2289V50.4684ZM60.2289 46.0124H57.299V43.3822H60.2289V46.0124ZM64.9855 50.4684H62.0556V47.8391H64.9855V50.4684ZM64.9855 46.0124H62.0556V43.3822H64.9855V46.0124ZM18.2725 39.2183H29.7648C30.2696 39.2183 30.6781 38.8094 30.6781 38.305V27.5387C30.6781 27.0344 30.2696 26.6254 29.7648 26.6254H18.2725C17.7677 26.6254 17.3592 27.0343 17.3592 27.5387V38.305C17.3592 38.8094 17.7677 39.2183 18.2725 39.2183ZM24.9315 28.452H28.8515V32.0085H24.9315V28.452ZM24.9315 33.8352H28.8515V37.3917H24.9315V33.8352ZM19.1858 28.452H23.1049V32.0085H19.1858V28.452ZM19.1858 33.8352H23.1049V37.3917H19.1858V33.8352ZM63.8403 65.8182V64.5722C63.8403 64.0674 64.2488 63.6589 64.7536 63.6589C65.2584 63.6589 65.6669 64.0674 65.6669 64.5722V65.8182C65.6669 66.323 65.2584 66.7315 64.7536 66.7315C64.2488 66.7315 63.8403 66.323 63.8403 65.8182ZM86.9675 42.1361L79.5513 36.5184V29.4608H80.0918C80.5966 29.4608 81.0051 29.0519 81.0051 28.5475V23.972C81.0051 23.4676 80.5966 23.0587 80.0918 23.0587H72.7469C72.2421 23.0587 71.8336 23.4676 71.8336 23.972V28.5475C71.8336 29.0519 72.2421 29.4608 72.7469 29.4608H73.2874V31.7735L61.6961 22.9931C61.0359 22.4462 60.3019 23.2261 59.7919 23.5999V7.26474L63.4862 8.80903C64.0579 9.07042 64.7734 8.5981 64.7518 7.96612V3.33582C64.7518 2.96746 64.5306 2.63522 64.1908 2.49296L59.2309 0.419715C59.0061 0.326064 58.751 0.325618 58.5263 0.420161L6.7963 22.0655C6.45648 22.2073 6.23528 22.5396 6.23528 22.9079V27.5387C6.22547 28.0286 6.65955 28.4628 7.1486 28.452C7.26812 28.452 7.38763 28.4289 7.50091 28.3811L12.7195 26.1975V41.5582C12.364 41.551 11.9473 41.537 11.6902 41.8258L1.18707 52.329C0.611393 52.8667 1.04246 53.9158 1.83281 53.888H5.3407V78.2095C5.3407 78.7144 5.74919 79.1229 6.25401 79.1229H83.7763C84.2811 79.1229 84.6896 78.7144 84.6896 78.2095V74.0907C84.6896 73.5859 84.2811 73.1774 83.7763 73.1774H81.1728V45.7127L83.1154 47.1844C86.516 49.6628 90.2401 44.7511 86.9675 42.1361ZM73.6602 24.8853H79.1785V27.6342C78.4196 27.6323 74.4194 27.6323 73.6602 27.6342V24.8853ZM77.7246 29.4608V35.1338L75.114 33.1555V29.4608H77.7246ZM8.06192 26.1665V23.5158L58.8786 2.25259L62.9252 3.9441V6.59442L59.2309 5.05007C59.1255 5.01651 59.0187 4.98597 58.9069 4.98541C58.5132 4.87726 8.44237 26.1002 8.06192 26.1665ZM57.9652 7.26558V24.9749C57.8372 25.0719 36.198 41.4739 36.0866 41.5582H14.5461V25.4338L57.9652 7.26558ZM4.03761 52.0614L12.7141 43.3849H34.3305C33.018 46.3429 36.5878 49.1529 39.1647 47.1905L41.1054 45.7203V52.0614H4.03761ZM37.5895 74.0907V77.2962H7.16733V53.888H41.1054V73.1774H38.5028C37.998 73.1774 37.5895 73.5859 37.5895 74.0907ZM82.863 75.004V77.2962H39.4162V75.004H82.863ZM67.9448 56.3747H54.3334C53.8286 56.3747 53.4201 56.7832 53.4201 57.288V73.1774H42.9321V44.3364L61.144 30.5387L79.3461 44.3312V73.1774H68.8582V57.288C68.8582 56.7832 68.4497 56.3747 67.9448 56.3747ZM67.0315 58.2013V72.999H55.2467V58.2013H67.0315ZM84.2266 45.7341L61.6961 28.6648C61.3696 28.4175 60.9184 28.4174 60.5919 28.6648L41.4667 43.1503L38.0622 45.7333C37.4664 46.1846 36.6173 46.0704 36.1669 45.4746C35.7127 44.911 35.8356 44.0162 36.422 43.5936C36.4247 43.5918 36.943 43.2006 36.9456 43.1993C36.9456 43.1993 59.4329 26.1569 59.4322 26.1549L61.1422 24.8657L85.866 43.5936C87.2247 44.6551 85.7077 46.8086 84.2266 45.7341ZM20.4871 57.8749H11.2273C10.7225 57.8749 10.314 58.2833 10.314 58.7882V71.6023C10.314 72.1071 10.7225 72.5156 11.2273 72.5156H20.4871C20.992 72.5156 21.4005 72.1071 21.4005 71.6023V58.7882C21.4005 58.2833 20.992 57.8749 20.4871 57.8749ZM19.5738 70.6889H12.1406V59.7015H19.5738V70.6889ZM37.0446 57.8749H27.7856C27.2808 57.8749 26.8723 58.2833 26.8723 58.7882V71.6023C26.8723 72.1071 27.2808 72.5156 27.7856 72.5156H37.0446C37.5494 72.5156 37.9579 72.1071 37.9579 71.6023V58.7882C37.9579 58.2833 37.5494 57.8749 37.0446 57.8749ZM36.1313 70.6889H28.699V59.7015H36.1313V70.6889Z"
                      fill="#8F5726"
                    />
                  </svg>
                  Villa
                </div>
                <div
                  className="card propertyTypeCard"
                  onClick={() => {
                    submitSearch("apartment");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    alt="divine-bricks-apartment"
                    title="divine-bricks-apartment"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M29.1844 79.3143H0.0883522V17.9984L14.6364 0.540771L29.1844 17.9984V79.3143ZM2.73344 76.6692H26.5393V18.9559L14.6364 4.67241L2.73344 18.9559V76.6692Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M79.4411 79.3143H50.3451V17.9984L64.8931 0.540771L79.4411 17.9984V79.3143ZM52.9902 76.6692H76.796V18.9559L64.8931 4.67241L52.9902 18.9559V76.6692Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M26.5393 47.5732H52.9902V79.3143H26.5393V47.5732ZM29.1844 76.6693H50.3451V50.2183H29.1844V76.6693Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.70108 52.8635H22.5716V79.3144H6.70108V52.8635ZM9.34618 76.6694H19.9265V55.5086H9.34618V76.6694Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.70108 18.4773H22.5716V36.9929H6.70108V18.4773ZM9.34618 34.3478H19.9265V21.1224H9.34618V34.3478Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M56.9578 52.8635H72.8284V79.3144H56.9578V52.8635ZM59.6029 76.6694H70.1833V55.5086H59.6029V76.6694Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M56.9578 18.4773H72.8284V36.9929H56.9578V18.4773ZM59.6029 34.3478H70.1833V21.1224H59.6029V34.3478Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M46.3775 56.8314H33.152C32.4206 56.8314 31.8295 56.2389 31.8295 55.5088C31.8295 54.7788 32.4206 54.1863 33.152 54.1863H46.3775C47.1088 54.1863 47.7 54.7788 47.7 55.5088C47.7 56.2389 47.1088 56.8314 46.3775 56.8314Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M46.3775 62.1214H33.152C32.4206 62.1214 31.8295 61.5289 31.8295 60.7989C31.8295 60.0688 32.4206 59.4763 33.152 59.4763H46.3775C47.1088 59.4763 47.7 60.0688 47.7 60.7989C47.7 61.5289 47.1088 62.1214 46.3775 62.1214Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M46.3775 67.4117H33.152C32.4206 67.4117 31.8295 66.8192 31.8295 66.0891C31.8295 65.3591 32.4206 64.7666 33.152 64.7666H46.3775C47.1088 64.7666 47.7 65.3591 47.7 66.0891C47.7 66.8192 47.1088 67.4117 46.3775 67.4117Z"
                      fill="#8F5726"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M46.3775 72.7017H33.152C32.4206 72.7017 31.8295 72.1092 31.8295 71.3792C31.8295 70.6491 32.4206 70.0566 33.152 70.0566H46.3775C47.1088 70.0566 47.7 70.6491 47.7 71.3792C47.7 72.1092 47.1088 72.7017 46.3775 72.7017Z"
                      fill="#8F5726"
                    />
                  </svg>
                  Apartment
                </div>
                <div
                  className="card propertyTypeCard"
                  onClick={() => {
                    submitSearch("commercial");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="82"
                    height="79"
                    viewBox="0 0 82 79"
                    fill="none"
                    alt="divine-bricks-commercial"
                    title="divine-bricks-commercial"
                  >
                    <path
                      d="M17.7876 23.0426V78.9464H63.527V23.0426C63.527 20.2474 61.3036 17.9604 58.6354 17.9604H22.6791C20.011 17.9604 17.7876 20.2474 17.7876 23.0426ZM49.5511 76.4053H31.7635V61.1588C31.7635 60.2059 31.7635 59.8883 34.3046 59.8883C34.4952 59.8883 34.6857 59.8883 34.9398 59.8883C35.194 59.8883 35.3845 59.8883 35.6386 59.8883H45.803C46.0571 59.8883 46.2476 59.8883 46.5018 59.8883C46.6923 59.8883 46.8829 59.8883 47.137 59.8883C49.6781 59.8883 49.6781 60.2059 49.6781 61.1588V76.4053H49.5511ZM60.9859 23.0426V76.4053H50.8216V61.1588C50.8216 58.8083 49.2334 58.6177 47.01 58.6177C46.6288 58.6177 46.1841 58.6177 45.7394 58.6177H35.5751C35.1304 58.6177 34.6857 58.6177 34.3046 58.6177C32.1447 58.6177 30.493 58.8083 30.493 61.1588V76.4053H20.3286V23.0426C20.3286 21.645 21.4086 20.5015 22.6791 20.5015H58.6354C59.906 20.5015 60.9859 21.645 60.9859 23.0426Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 29.3954H26.6813C27.3801 29.3954 27.9519 28.8237 27.9519 28.1249V24.3133C27.9519 23.6145 27.3801 23.0427 26.6813 23.0427H24.1402C23.4414 23.0427 22.8697 23.6145 22.8697 24.3133V28.1249C22.8697 28.8237 23.4414 29.3954 24.1402 29.3954ZM24.1402 24.3133H26.6813V28.1249H24.1402V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M31.7635 29.3954H34.3046C35.0034 29.3954 35.5751 28.8237 35.5751 28.1249V24.3133C35.5751 23.6145 35.0034 23.0427 34.3046 23.0427H31.7635C31.0647 23.0427 30.493 23.6145 30.493 24.3133V28.1249C30.493 28.8237 31.0647 29.3954 31.7635 29.3954ZM31.7635 24.3133H34.3046V28.1249H31.7635V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M39.3868 29.3954H41.9278C42.6266 29.3954 43.1984 28.8237 43.1984 28.1249V24.3133C43.1984 23.6145 42.6266 23.0427 41.9278 23.0427H39.3868C38.688 23.0427 38.1162 23.6145 38.1162 24.3133V28.1249C38.1162 28.8237 38.688 29.3954 39.3868 29.3954ZM39.3868 24.3133H41.9278V28.1249H39.3868V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M47.01 29.3954H49.5511C50.2499 29.3954 50.8216 28.8237 50.8216 28.1249V24.3133C50.8216 23.6145 50.2499 23.0427 49.5511 23.0427H47.01C46.3112 23.0427 45.7394 23.6145 45.7394 24.3133V28.1249C45.7394 28.8237 46.3112 29.3954 47.01 29.3954ZM47.01 24.3133H49.5511V28.1249H47.01V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 29.3954H57.1743C57.8731 29.3954 58.4448 28.8237 58.4448 28.1249V24.3133C58.4448 23.6145 57.8731 23.0427 57.1743 23.0427H54.6332C53.9344 23.0427 53.3627 23.6145 53.3627 24.3133V28.1249C53.3627 28.8237 53.9344 29.3954 54.6332 29.3954ZM54.6332 24.3133H57.1743V28.1249H54.6332V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 38.2892H26.6813C27.3801 38.2892 27.9519 37.7175 27.9519 37.0187V33.2071C27.9519 32.5083 27.3801 31.9365 26.6813 31.9365H24.1402C23.4414 31.9365 22.8697 32.5083 22.8697 33.2071V37.0187C22.8697 37.7175 23.4414 38.2892 24.1402 38.2892ZM24.1402 33.2071H26.6813V37.0187H24.1402V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M31.7635 38.2892H34.3046C35.0034 38.2892 35.5751 37.7175 35.5751 37.0187V33.2071C35.5751 32.5083 35.0034 31.9365 34.3046 31.9365H31.7635C31.0647 31.9365 30.493 32.5083 30.493 33.2071V37.0187C30.493 37.7175 31.0647 38.2892 31.7635 38.2892ZM31.7635 33.2071H34.3046V37.0187H31.7635V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M39.3868 38.2892H41.9278C42.6266 38.2892 43.1984 37.7175 43.1984 37.0187V33.2071C43.1984 32.5083 42.6266 31.9365 41.9278 31.9365H39.3868C38.688 31.9365 38.1162 32.5083 38.1162 33.2071V37.0187C38.1162 37.7175 38.688 38.2892 39.3868 38.2892ZM39.3868 33.2071H41.9278V37.0187H39.3868V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M47.01 38.2892H49.5511C50.2499 38.2892 50.8216 37.7175 50.8216 37.0187V33.2071C50.8216 32.5083 50.2499 31.9365 49.5511 31.9365H47.01C46.3112 31.9365 45.7394 32.5083 45.7394 33.2071V37.0187C45.7394 37.7175 46.3112 38.2892 47.01 38.2892ZM47.01 33.2071H49.5511V37.0187H47.01V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 38.2892H57.1743C57.8731 38.2892 58.4448 37.7175 58.4448 37.0187V33.2071C58.4448 32.5083 57.8731 31.9365 57.1743 31.9365H54.6332C53.9344 31.9365 53.3627 32.5083 53.3627 33.2071V37.0187C53.3627 37.7175 53.9344 38.2892 54.6332 38.2892ZM54.6332 33.2071H57.1743V37.0187H54.6332V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 47.183H26.6813C27.3801 47.183 27.9519 46.6113 27.9519 45.9125V42.1009C27.9519 41.4021 27.3801 40.8303 26.6813 40.8303H24.1402C23.4414 40.8303 22.8697 41.4021 22.8697 42.1009V45.9125C22.8697 46.6113 23.4414 47.183 24.1402 47.183ZM24.1402 42.1009H26.6813V45.9125H24.1402V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M31.7635 47.183H34.3046C35.0034 47.183 35.5751 46.6113 35.5751 45.9125V42.1009C35.5751 41.4021 35.0034 40.8303 34.3046 40.8303H31.7635C31.0647 40.8303 30.493 41.4021 30.493 42.1009V45.9125C30.493 46.6113 31.0647 47.183 31.7635 47.183ZM31.7635 42.1009H34.3046V45.9125H31.7635V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M39.3868 47.183H41.9278C42.6266 47.183 43.1984 46.6113 43.1984 45.9125V42.1009C43.1984 41.4021 42.6266 40.8303 41.9278 40.8303H39.3868C38.688 40.8303 38.1162 41.4021 38.1162 42.1009V45.9125C38.1162 46.6113 38.688 47.183 39.3868 47.183ZM39.3868 42.1009H41.9278V45.9125H39.3868V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M47.01 47.183H49.5511C50.2499 47.183 50.8216 46.6113 50.8216 45.9125V42.1009C50.8216 41.4021 50.2499 40.8303 49.5511 40.8303H47.01C46.3112 40.8303 45.7394 41.4021 45.7394 42.1009V45.9125C45.7394 46.6113 46.3112 47.183 47.01 47.183ZM47.01 42.1009H49.5511V45.9125H47.01V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 47.183H57.1743C57.8731 47.183 58.4448 46.6113 58.4448 45.9125V42.1009C58.4448 41.4021 57.8731 40.8303 57.1743 40.8303H54.6332C53.9344 40.8303 53.3627 41.4021 53.3627 42.1009V45.9125C53.3627 46.6113 53.9344 47.183 54.6332 47.183ZM54.6332 42.1009H57.1743V45.9125H54.6332V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 56.0768H26.6813C27.3801 56.0768 27.9519 55.5051 27.9519 54.8063V50.9947C27.9519 50.2959 27.3801 49.7241 26.6813 49.7241H24.1402C23.4414 49.7241 22.8697 50.2959 22.8697 50.9947V54.8063C22.8697 55.5051 23.4414 56.0768 24.1402 56.0768ZM24.1402 50.9947H26.6813V54.8063H24.1402V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M31.7635 56.0768H34.3046C35.0034 56.0768 35.5751 55.5051 35.5751 54.8063V50.9947C35.5751 50.2959 35.0034 49.7241 34.3046 49.7241H31.7635C31.0647 49.7241 30.493 50.2959 30.493 50.9947V54.8063C30.493 55.5051 31.0647 56.0768 31.7635 56.0768ZM31.7635 50.9947H34.3046V54.8063H31.7635V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M39.3868 56.0768H41.9278C42.6266 56.0768 43.1984 55.5051 43.1984 54.8063V50.9947C43.1984 50.2959 42.6266 49.7241 41.9278 49.7241H39.3868C38.688 49.7241 38.1162 50.2959 38.1162 50.9947V54.8063C38.1162 55.5051 38.688 56.0768 39.3868 56.0768ZM39.3868 50.9947H41.9278V54.8063H39.3868V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M47.01 56.0768H49.5511C50.2499 56.0768 50.8216 55.5051 50.8216 54.8063V50.9947C50.8216 50.2959 50.2499 49.7241 49.5511 49.7241H47.01C46.3112 49.7241 45.7394 50.2959 45.7394 50.9947V54.8063C45.7394 55.5051 46.3112 56.0768 47.01 56.0768ZM47.01 50.9947H49.5511V54.8063H47.01V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 56.0768H57.1743C57.8731 56.0768 58.4448 55.5051 58.4448 54.8063V50.9947C58.4448 50.2959 57.8731 49.7241 57.1743 49.7241H54.6332C53.9344 49.7241 53.3627 50.2959 53.3627 50.9947V54.8063C53.3627 55.5051 53.9344 56.0768 54.6332 56.0768ZM54.6332 50.9947H57.1743V54.8063H54.6332V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 64.9706H26.6813C27.3801 64.9706 27.9519 64.3989 27.9519 63.7001V59.8885C27.9519 59.1897 27.3801 58.6179 26.6813 58.6179H24.1402C23.4414 58.6179 22.8697 59.1897 22.8697 59.8885V63.7001C22.8697 64.3989 23.4414 64.9706 24.1402 64.9706ZM24.1402 59.8885H26.6813V63.7001H24.1402V59.8885Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 64.9706H57.1743C57.8731 64.9706 58.4448 64.3989 58.4448 63.7001V59.8885C58.4448 59.1897 57.8731 58.6179 57.1743 58.6179H54.6332C53.9344 58.6179 53.3627 59.1897 53.3627 59.8885V63.7001C53.3627 64.3989 53.9344 64.9706 54.6332 64.9706ZM54.6332 59.8885H57.1743V63.7001H54.6332V59.8885Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M24.1402 73.8644H26.6813C27.3801 73.8644 27.9519 73.2927 27.9519 72.5939V68.7823C27.9519 68.0835 27.3801 67.5117 26.6813 67.5117H24.1402C23.4414 67.5117 22.8697 68.0835 22.8697 68.7823V72.5939C22.8697 73.2927 23.4414 73.8644 24.1402 73.8644ZM24.1402 68.7823H26.6813V72.5939H24.1402V68.7823Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M54.6332 73.8644H57.1743C57.8731 73.8644 58.4448 73.2927 58.4448 72.5939V68.7823C58.4448 68.0835 57.8731 67.5117 57.1743 67.5117H54.6332C53.9344 67.5117 53.3627 68.0835 53.3627 68.7823V72.5939C53.3627 73.2927 53.9344 73.8644 54.6332 73.8644ZM54.6332 68.7823H57.1743V72.5939H54.6332V68.7823Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 6.52591C10.1643 5.82711 9.59257 5.25537 8.89377 5.25537H6.35269C5.6539 5.25537 5.08215 5.82711 5.08215 6.52591V10.3375C5.08215 11.0363 5.6539 11.6081 6.35269 11.6081H8.89377C9.59257 11.6081 10.1643 11.0363 10.1643 10.3375V6.52591ZM8.89377 10.3375H6.35269V6.52591H8.89377V10.3375Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M13.9759 11.6081H16.517C17.2158 11.6081 17.7876 11.0363 17.7876 10.3375V6.52591C17.7876 5.82711 17.2158 5.25537 16.517 5.25537H13.9759C13.2771 5.25537 12.7054 5.82711 12.7054 6.52591V10.3375C12.7054 11.0363 13.2771 11.6081 13.9759 11.6081ZM13.9759 6.52591H16.517V10.3375H13.9759V6.52591Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M21.5992 11.6081H24.1403C24.8391 11.6081 25.4108 11.0363 25.4108 10.3375V6.52591C25.4108 5.82711 24.8391 5.25537 24.1403 5.25537H21.5992C20.9004 5.25537 20.3287 5.82711 20.3287 6.52591V10.3375C20.3287 11.0363 20.9004 11.6081 21.5992 11.6081ZM21.5992 6.52591H24.1403V10.3375H21.5992V6.52591Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 15.4197C10.1643 14.7209 9.59257 14.1492 8.89377 14.1492H6.35269C5.6539 14.1492 5.08215 14.7209 5.08215 15.4197V19.2313C5.08215 19.9301 5.6539 20.5019 6.35269 20.5019H8.89377C9.59257 20.5019 10.1643 19.9301 10.1643 19.2313V15.4197ZM8.89377 19.2313H6.35269V15.4197H8.89377V19.2313Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 19.2313C12.7054 19.9301 13.2771 20.5019 13.9759 20.5019H16.517C17.2158 20.5019 17.7876 19.9301 17.7876 19.2313V15.4197C17.7876 14.7209 17.2158 14.1492 16.517 14.1492H13.9759C13.2771 14.1492 12.7054 14.7209 12.7054 15.4197V19.2313ZM13.9759 15.4197H16.517V19.2313H13.9759V15.4197Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 24.3133C10.1643 23.6145 9.59257 23.0427 8.89377 23.0427H6.35269C5.6539 23.0427 5.08215 23.6145 5.08215 24.3133V28.1249C5.08215 28.8237 5.6539 29.3954 6.35269 29.3954H8.89377C9.59257 29.3954 10.1643 28.8237 10.1643 28.1249V24.3133ZM8.89377 28.1249H6.35269V24.3133H8.89377V28.1249Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 33.2071C10.1643 32.5083 9.59257 31.9365 8.89377 31.9365H6.35269C5.6539 31.9365 5.08215 32.5083 5.08215 33.2071V37.0187C5.08215 37.7175 5.6539 38.2892 6.35269 38.2892H8.89377C9.59257 38.2892 10.1643 37.7175 10.1643 37.0187V33.2071ZM8.89377 37.0187H6.35269V33.2071H8.89377V37.0187Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 42.1009C10.1643 41.4021 9.59257 40.8303 8.89377 40.8303H6.35269C5.6539 40.8303 5.08215 41.4021 5.08215 42.1009V45.9125C5.08215 46.6113 5.6539 47.183 6.35269 47.183H8.89377C9.59257 47.183 10.1643 46.6113 10.1643 45.9125V42.1009ZM8.89377 45.9125H6.35269V42.1009H8.89377V45.9125Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 50.9947C10.1643 50.2959 9.59257 49.7241 8.89377 49.7241H6.35269C5.6539 49.7241 5.08215 50.2959 5.08215 50.9947V54.8063C5.08215 55.5051 5.6539 56.0768 6.35269 56.0768H8.89377C9.59257 56.0768 10.1643 55.5051 10.1643 54.8063V50.9947ZM8.89377 54.8063H6.35269V50.9947H8.89377V54.8063Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M10.1643 59.8885C10.1643 59.1897 9.59257 58.6179 8.89377 58.6179H6.35269C5.6539 58.6179 5.08215 59.1897 5.08215 59.8885V63.7001C5.08215 64.3989 5.6539 64.9706 6.35269 64.9706H8.89377C9.59257 64.9706 10.1643 64.3989 10.1643 63.7001V59.8885ZM8.89377 63.7001H6.35269V59.8885H8.89377V63.7001Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M8.89377 67.5117H6.35269C5.6539 67.5117 5.08215 68.0835 5.08215 68.7823V72.5939C5.08215 73.2927 5.6539 73.8644 6.35269 73.8644H8.89377C9.59257 73.8644 10.1643 73.2927 10.1643 72.5939V68.7823C10.1643 68.0835 9.59257 67.5117 8.89377 67.5117ZM8.89377 72.5939H6.35269V68.7823H8.89377V72.5939Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 45.9125C12.7054 46.6113 13.2771 47.183 13.9759 47.183H15.2465V45.9125H13.9759V42.1009H15.2465V40.8303H13.9759C13.2771 40.8303 12.7054 41.4021 12.7054 42.1009V45.9125Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 37.0187C12.7054 37.7175 13.2771 38.2892 13.9759 38.2892H15.2465V37.0187H13.9759V33.2071H15.2465V31.9365H13.9759C13.2771 31.9365 12.7054 32.5083 12.7054 33.2071V37.0187Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 28.1249C12.7054 28.8237 13.2771 29.3954 13.9759 29.3954H15.2465V28.1249H13.9759V24.3133H15.2465V23.0427H13.9759C13.2771 23.0427 12.7054 23.6145 12.7054 24.3133V28.1249Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M15.2465 76.4055H2.54108V5.25526C2.54108 3.85766 3.68457 2.71418 5.01863 2.71418H25.4743C26.8719 2.71418 27.9519 3.85766 27.9519 5.25526V15.4196H30.493V5.25526C30.493 2.46007 28.2695 0.173096 25.4743 0.173096H5.01863C2.22345 0.173096 0 2.46007 0 5.25526V78.9466H15.2465V76.4055Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 54.8063C12.7054 55.5051 13.2771 56.0768 13.9759 56.0768H15.2465V54.8063H13.9759V50.9947H15.2465V49.7241H13.9759C13.2771 49.7241 12.7054 50.2959 12.7054 50.9947V54.8063Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 63.7001C12.7054 64.3989 13.2771 64.9706 13.9759 64.9706H15.2465V63.7001H13.9759V59.8885H15.2465V58.6179H13.9759C13.2771 58.6179 12.7054 59.1897 12.7054 59.8885V63.7001Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M12.7054 72.5939C12.7054 73.2927 13.2771 73.8644 13.9759 73.8644H15.2465V72.5939H13.9759V68.7823H15.2465V67.5117H13.9759C13.2771 67.5117 12.7054 68.0835 12.7054 68.7823V72.5939Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M20.3287 15.8009C20.7098 15.6738 21.1545 15.5468 21.5992 15.4832V15.4197H22.6792H24.1403H25.4108C25.4108 14.7209 24.8391 14.1492 24.1403 14.1492H21.5992C20.9004 14.1492 20.3287 14.7209 20.3287 15.4197V15.8009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M72.4208 11.6081H74.9619C75.6607 11.6081 76.2324 11.0363 76.2324 10.3375V6.52591C76.2324 5.82711 75.6607 5.25537 74.9619 5.25537H72.4208C71.722 5.25537 71.1502 5.82711 71.1502 6.52591V10.3375C71.1502 11.0363 71.722 11.6081 72.4208 11.6081ZM72.4208 6.52591H74.9619V10.3375H72.4208V6.52591Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M64.7975 11.6081H67.3386C68.0374 11.6081 68.6092 11.0363 68.6092 10.3375V6.52591C68.6092 5.82711 68.0374 5.25537 67.3386 5.25537H64.7975C64.0988 5.25537 63.527 5.82711 63.527 6.52591V10.3375C63.527 11.0363 64.0988 11.6081 64.7975 11.6081ZM64.7975 6.52591H67.3386V10.3375H64.7975V6.52591Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M57.1743 11.6081H59.7154C60.4142 11.6081 60.9859 11.0363 60.9859 10.3375V6.52591C60.9859 5.82711 60.4142 5.25537 59.7154 5.25537H57.1743C56.4755 5.25537 55.9038 5.82711 55.9038 6.52591V10.3375C55.9038 11.0363 56.4755 11.6081 57.1743 11.6081ZM57.1743 6.52591H59.7154V10.3375H57.1743V6.52591Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 19.2313C71.1502 19.9301 71.722 20.5019 72.4208 20.5019H74.9619C75.6607 20.5019 76.2324 19.9301 76.2324 19.2313V15.4197C76.2324 14.7209 75.6607 14.1492 74.9619 14.1492H72.4208C71.722 14.1492 71.1502 14.7209 71.1502 15.4197V19.2313ZM72.4208 15.4197H74.9619V19.2313H72.4208V15.4197Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M63.527 19.2313C63.527 19.9301 64.0988 20.5019 64.7975 20.5019H67.3386C68.0374 20.5019 68.6092 19.9301 68.6092 19.2313V15.4197C68.6092 14.7209 68.0374 14.1492 67.3386 14.1492H64.7975C64.0988 14.1492 63.527 14.7209 63.527 15.4197V19.2313ZM64.7975 15.4197H67.3386V19.2313H64.7975V15.4197Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 28.1249C71.1502 28.8237 71.722 29.3954 72.4208 29.3954H74.9619C75.6607 29.3954 76.2324 28.8237 76.2324 28.1249V24.3133C76.2324 23.6145 75.6607 23.0427 74.9619 23.0427H72.4208C71.722 23.0427 71.1502 23.6145 71.1502 24.3133V28.1249ZM72.4208 24.3133H74.9619V28.1249H72.4208V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 37.0187C71.1502 37.7175 71.722 38.2892 72.4208 38.2892H74.9619C75.6607 38.2892 76.2324 37.7175 76.2324 37.0187V33.2071C76.2324 32.5083 75.6607 31.9365 74.9619 31.9365H72.4208C71.722 31.9365 71.1502 32.5083 71.1502 33.2071V37.0187ZM72.4208 33.2071H74.9619V37.0187H72.4208V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 45.9125C71.1502 46.6113 71.722 47.183 72.4208 47.183H74.9619C75.6607 47.183 76.2324 46.6113 76.2324 45.9125V42.1009C76.2324 41.4021 75.6607 40.8303 74.9619 40.8303H72.4208C71.722 40.8303 71.1502 41.4021 71.1502 42.1009V45.9125ZM72.4208 42.1009H74.9619V45.9125H72.4208V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 54.8063C71.1502 55.5051 71.722 56.0768 72.4208 56.0768H74.9619C75.6607 56.0768 76.2324 55.5051 76.2324 54.8063V50.9947C76.2324 50.2959 75.6607 49.7241 74.9619 49.7241H72.4208C71.722 49.7241 71.1502 50.2959 71.1502 50.9947V54.8063ZM72.4208 50.9947H74.9619V54.8063H72.4208V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 63.7001C71.1502 64.3989 71.722 64.9706 72.4208 64.9706H74.9619C75.6607 64.9706 76.2324 64.3989 76.2324 63.7001V59.8885C76.2324 59.1897 75.6607 58.6179 74.9619 58.6179H72.4208C71.722 58.6179 71.1502 59.1897 71.1502 59.8885V63.7001ZM72.4208 59.8885H74.9619V63.7001H72.4208V59.8885Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M71.1502 72.5939C71.1502 73.2927 71.722 73.8644 72.4208 73.8644H74.9619C75.6607 73.8644 76.2324 73.2927 76.2324 72.5939V68.7823C76.2324 68.0835 75.6607 67.5117 74.9619 67.5117H72.4208C71.722 67.5117 71.1502 68.0835 71.1502 68.7823V72.5939ZM72.4208 68.7823H74.9619V72.5939H72.4208V68.7823Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M68.6092 42.1009C68.6092 41.4021 68.0374 40.8303 67.3386 40.8303H66.0681V42.1009H67.3386V45.9125H66.0681V47.183H67.3386C68.0374 47.183 68.6092 46.6113 68.6092 45.9125V42.1009Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M68.6092 33.2071C68.6092 32.5083 68.0374 31.9365 67.3386 31.9365H66.0681V33.2071H67.3386V37.0187H66.0681V38.2892H67.3386C68.0374 38.2892 68.6092 37.7175 68.6092 37.0187V33.2071Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M68.6092 24.3133C68.6092 23.6145 68.0374 23.0427 67.3386 23.0427H66.0681V24.3133H67.3386V28.1249H66.0681V29.3954H67.3386C68.0374 29.3954 68.6092 28.8237 68.6092 28.1249V24.3133Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M76.2959 0.173096H55.8402C53.0451 0.173096 50.8216 2.46007 50.8216 5.25526V15.4196H53.3627V5.25526C53.3627 3.85766 54.5062 2.71418 55.8402 2.71418H76.2959C77.6935 2.71418 78.7735 3.85766 78.7735 5.25526V76.4055H66.0681V78.9466H81.3146V5.25526C81.3146 2.46007 79.0911 0.173096 76.2959 0.173096Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M68.6092 50.9947C68.6092 50.2959 68.0374 49.7241 67.3386 49.7241H66.0681V50.9947H67.3386V54.8063H66.0681V56.0768H67.3386C68.0374 56.0768 68.6092 55.5051 68.6092 54.8063V50.9947Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M68.6092 59.8885C68.6092 59.1897 68.0374 58.6179 67.3386 58.6179H66.0681V59.8885H67.3386V63.7001H66.0681V64.9706H67.3386C68.0374 64.9706 68.6092 64.3989 68.6092 63.7001V59.8885Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M66.0681 72.5939V73.8644H67.3386C68.0374 73.8644 68.6092 73.2927 68.6092 72.5939V68.7823C68.6092 68.0835 68.0374 67.5117 67.3386 67.5117H66.0681V68.7823H67.3386V72.5939H66.0681Z"
                      fill="#8F5726"
                    />
                    <path
                      d="M57.1743 15.4197H58.6354H59.7154V15.4832C60.1601 15.5468 60.6048 15.6738 60.9859 15.8009V15.4197C60.9859 14.7209 60.4142 14.1492 59.7154 14.1492H57.1743C56.4755 14.1492 55.9038 14.7209 55.9038 15.4197H57.1743Z"
                      fill="#8F5726"
                    />
                  </svg>
                  Commercial
                </div>
                <div
                  className="card propertyTypeCard"
                  onClick={() => {
                    submitSearch("residential");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="106"
                    height="80"
                    viewBox="0 0 106 80"
                    fill="none"
                    alt="divine-bricks-residential"
                    title="divine-bricks-residential"
                  >
                    <path
                      d="M103.777 69.8971C104.504 66.3034 102.077 62.722 98.6497 61.8805V44.3339C99.168 44.5303 101.58 45.9752 102.149 45.8776C103.939 45.9163 104.584 43.3513 102.933 42.5612L78.4267 30.3078C77.2592 29.6367 75.6055 31.0678 74.1427 31.6668V14.5755L76.8608 15.9346C77.7073 16.362 78.7748 16.0249 79.2096 15.1516C79.6421 14.2866 79.2917 13.2353 78.4267 12.8028L53.9197 0.549362C53.4274 0.303207 52.8462 0.303207 52.3539 0.549362L27.847 12.8028C26.982 13.2353 26.6315 14.2866 27.064 15.1516C27.4982 16.0158 28.5478 16.3679 29.4128 15.9346L32.1309 14.5755V31.6668C30.713 31.0846 28.9868 29.6324 27.8469 30.3077L3.34002 42.5612C1.3049 43.6211 2.82356 46.6854 4.906 45.6929L7.62393 44.3339V61.8805C4.19678 62.7217 1.7689 66.3038 2.49693 69.8971C-1.21165 72.8588 1.04912 79.2381 5.87367 79.1369L100.4 79.137C105.19 79.2419 107.515 72.86 103.777 69.8971ZM100.4 68.634H91.6477C91.6477 67.7605 92.3093 67.0202 93.1862 66.9143C93.6119 66.8613 94.005 66.6561 94.2888 66.3348C96.2896 63.889 100.491 65.5031 100.4 68.634ZM77.6437 33.8309L95.1487 42.5834V61.8884C94.0214 62.187 92.9671 62.7422 92.1041 63.562C89.8066 64.1432 88.1467 66.2185 88.1467 68.634H86.3962V58.131C86.3962 54.2693 83.2559 51.129 79.3942 51.129H75.8932C72.0316 51.129 68.8913 54.2693 68.8913 58.131V68.634H60.1388V42.5834L77.6437 33.8309ZM82.8952 58.131V68.634H72.3923V58.131C72.3923 56.201 73.9633 54.63 75.8932 54.63H79.3942C81.3242 54.63 82.8952 56.201 82.8952 58.131ZM35.6319 12.825L53.1368 4.07256L70.6417 12.825V33.4173L53.1368 42.1697L35.6319 33.4173V12.825ZM56.6378 44.3339V68.634H49.6358V44.3339C50.2072 44.5896 52.5276 45.9029 53.1351 45.8776C53.7488 45.9274 56.0735 44.5707 56.6378 44.3339ZM11.125 42.5834L28.6299 33.831L46.1348 42.5834V68.634H37.3824V58.1311C37.3824 54.2694 34.2421 51.1291 30.3804 51.1291H26.8794C23.0177 51.1291 19.8774 54.2694 19.8774 58.1311V68.634H18.1269C18.1269 66.2185 16.467 64.1432 14.1695 63.562C13.3066 62.7422 12.2522 62.1871 11.125 61.8885V42.5834ZM33.8814 58.1311V68.634H23.3784V58.1311C23.3784 56.2011 24.9494 54.6301 26.8794 54.6301H30.3804C32.3104 54.6301 33.8814 56.2011 33.8814 58.1311ZM9.37446 65.133C10.3745 65.133 11.301 65.5587 11.9848 66.3348C12.2686 66.6561 12.6618 66.8613 13.0874 66.9143C13.9644 67.0203 14.6259 67.7605 14.6259 68.634H5.87348C5.87348 66.704 7.44447 65.133 9.37446 65.133ZM100.4 75.636H5.87348C3.60928 75.6061 3.54359 72.178 5.87358 72.135H100.4C102.664 72.1649 102.73 75.5929 100.4 75.636Z"
                      fill="#8F5726"
                    />
                  </svg>
                  Residential
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default HomePagePropertyType;
